import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
            _ctx.$style['modal-component'],
            $props.containerClass,
            $props.fullSizeOnMobile ? _ctx.$style['full-size-on-mobile'] : '',
            _ctx.$style[$props.mobile ? 'mobile' : 'desktop'],
        ])
  }, [
    _createVNode(_Transition, {
      "enter-active-class": _ctx.$style['overlay-enter'],
      "leave-active-class": _ctx.$style['overlay-leave']
    }, {
      default: _withCtx(() => [
        ($props.open)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(_ctx.$style['overlay']),
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.setOpen(false)))
            }, null, 2 /* CLASS */))
          : _createCommentVNode("v-if", true)
      ], undefined, true),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["enter-active-class", "leave-active-class"]),
    _createVNode(_Transition, {
      "enter-active-class": _ctx.$style['menu-enter'],
      "leave-active-class": _ctx.$style['menu-leave'],
      persisted: ""
    }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          class: _normalizeClass([_ctx.$style['modal-content'], $props.contentClass]),
          tabindex: "0",
          ref: "modalContent"
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$style['close-btn-position-left'])
          }, [
            _renderSlot(_ctx.$slots, "close-button-left")
          ], 2 /* CLASS */),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$style['close-btn-position'])
          }, [
            _renderSlot(_ctx.$slots, "close-button", {
              close: () => $options.setOpen(false)
            })
          ], 2 /* CLASS */),
          _renderSlot(_ctx.$slots, "default")
        ], 2 /* CLASS */), [
          [_vShow, $props.open]
        ])
      ], undefined, true),
      _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["enter-active-class", "leave-active-class"])
  ], 2 /* CLASS */))
}